import styled from "@emotion/styled"
import Title from "components/Title"

const ListFourteenTitle = styled(Title)`
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    font-size: 36px;
    margin-bottom: 42px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    font-size: 36px;
    margin-bottom: 63px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    margin-bottom: 83px;
    font-size: 45px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    margin-bottom: 104px;
    font-size: 60px;
  }
`

export default ListFourteenTitle
